import { createListenerMiddleware } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '@/store/store'
import { ResponseFeedbackActions } from './slice'
import getFeedbackReasons from '../fetch/get-feedback-reasons'

export const responseFeedbackListenerMiddleware = createListenerMiddleware()
const startListener = responseFeedbackListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()

/**
 * Response Feedback: Fetch Feedback Reasons
 */
startListener({
  actionCreator: ResponseFeedbackActions.fetchFeedbackReasons,
  effect: async (_action, listenerApi) => {
    const { dispatch, getState } = listenerApi

    // Get the existing state
    const state = getState()
    const currentData = state.responseFeedbackState.feedbackReasonsData
    const currentLoading = state.responseFeedbackState.feedbackReasonsLoading

    // Avoid reloading if the data is already present or if currently loading
    if (currentLoading || currentData.negative_reasons.length > 0) {
      return
    }

    dispatch(ResponseFeedbackActions.setFeedbackReasonsLoading(true))
    dispatch(ResponseFeedbackActions.setFeedbackReasonsError(false))
    try {
      console.log('Fetching feedback reasons...')
      const feedbackReasons = await getFeedbackReasons()
      console.log('Feedback reasons fetched successfully:', feedbackReasons)
      dispatch(ResponseFeedbackActions.setFeedbackReasonsData(feedbackReasons))
    } catch (e) {
      console.error('Error fetching feedback reasons:', e)
      dispatch(ResponseFeedbackActions.setFeedbackReasonsError(true))
    } finally {
      dispatch(ResponseFeedbackActions.setFeedbackReasonsLoading(false))
    }
  },
})
